import styled, { css, keyframes } from 'styled-components';
import { IconSpinner1 } from '@99designs/icons';
import { colors, typography } from '@99designs/ui/settings';

const spinnerSpin = keyframes`
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(359deg);
    }
`;

type SpinnerSize = 'small' | 'medium' | 'large' | 'default';

const sizeToHeightAndWidth: Record<SpinnerSize, number> = {
    small: typography.typeScale.size2,
    default: typography.typeScale.size3,
    medium: typography.typeScale.size5,
    large: typography.typeScale.size6,
};

export interface SpinnerProps {
    color?: colors.Color;
    inline?: boolean;
    size?: SpinnerSize;
}

const Spinner = styled(IconSpinner1)<SpinnerProps>`
    animation: ${spinnerSpin} 0.7s infinite linear;
    color: ${({ color = 'fiftyFirstShade' }) => colors.colors[color]};
    display: ${({ inline = false }) => (inline ? 'inline' : 'block')};
    z-index: 10;

    ${({ size = 'default' }) => css`
        height: ${sizeToHeightAndWidth[size]}px;
        width: ${sizeToHeightAndWidth[size]}px;
    `}
`;

export default Spinner;
